import TEXT from '../../data/text.json';

const textMapping = (filterName, filterValue) => {
  let text;

  if (filterName === 'glassType') {
    text = TEXT.MAPPINGS.GLASS_TYPES[filterValue];
  } else if (filterName === 'productionLocation') {
    text = TEXT.MAPPINGS.PRODUCTION_LOCATIONS[filterValue];
  } else if (filterName === 'productionMethod') {
    text = TEXT.MAPPINGS.PRODUCTION_METHODS[filterValue];
  } else {
    text = filterValue;
  }

  return text || 'Unknown';
};

export default textMapping;



// WEBPACK FOOTER //
// ./src/utils/textMapping.js